<template>
  <div>
    <v-dialog v-model="bDialog"  max-width="700px" persistent>
      <v-card flat tile ref="form">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">corporate_fare</v-icon>협력업체 등록
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <v-card-text v-if="bStep == 1" class="pa-4 pt-0 mt-4">
          <v-row>
            <v-col cols="12" sm="6">
              <v-card flat>
                <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold">
                  기업 구분
                </div>
                <v-radio-group v-model="editedItem.cLocal" dense mandatory row @change="ChangeFocus()" class="mt-2">
                  <v-radio label="국내기업" value="Y"></v-radio>
                  <v-radio label="해외기업" value="N"></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" v-if="editedItem.cLocal == 'N'">
              <v-card flat>
                <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold">
                  사업자 번호 입력<strong class="red--text">*</strong>
                </div>
                <v-text-field @keyup.enter="CheckBizCodeEng();" v-model="editedItem.cBizCode" ref="cBizCodeEngRef" dense class="mt-2" hint=" '-' 빼고 9자리 숫자만 입력하여 주세요">
                  <template v-slot:label>
                    사업자 번호<strong class="red--text">*</strong>
                  </template>
                  <template v-slot:append-outer>
                    <v-btn @click="CheckBizCodeEng()" dark small><v-icon>check</v-icon>조회</v-btn>
                  </template>
                </v-text-field>
                <!-- <v-text-field v-model="editedItem.cBizCode" ref="cBizCodeEngRef" dense class="mt-2" hint=" '-' 빼고 10자리 숫자만 입력하여 주세요">
                  <template v-slot:label>
                    사업자 번호<strong class="red--text">*</strong>
                  </template>
                </v-text-field> -->
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6" v-if="editedItem.cLocal == 'Y'">
              <v-card flat>
                <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold d-flex">
                  사업자 번호 조회<strong class="red--text">*</strong>
                </div>
                <v-text-field @keyup.enter="UseAPI();" v-model="editedItem.cBizCode" ref="cBizCodeKorRef" dense class="mt-2" hint=" '-' 빼고 10자리 숫자만 입력하여 주세요">
                  <template v-slot:append-outer>
                    <v-btn @click="UseAPI()" dark small><v-icon>check</v-icon>조회</v-btn>
                  </template>
                </v-text-field>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="mb-3"></v-divider>
              <v-btn @click="Close()" class="mr-2 mb-2" text><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
              <!-- <v-btn v-if="editedItem.cLocal == 'N'" @click="CheckBizCodeEng()" class="ml-2 mb-2" dark><v-icon class="mr-1">mdi-chevron-right</v-icon>다음</v-btn> -->
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text v-if="bStep == 2 && editedItem.cLocal == 'Y'" class="pa-4 pt-0 mt-4">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field dense class="mb-n2" v-model="editedItem.cBizCode" ref="cBizCode" disabled>
                <template v-slot:label>
                  <div>사업자번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
              <div></div>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" value="국내" label="기업구분" disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCorpNmKor" ref="cCorpNmKor">
                <template v-slot:label>
                  <div>회사명(한글)<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCorpNmEng" label="회사명(영문)"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cCEO">
                <template v-slot:label>
                  <div>대표자명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <v-text-field dense class="mb-n2 " v-model="editedItem.cHomePage" label="홈페이지" hint="ex) https://www.sk-materials.com"></v-text-field> -->
              <v-text-field dense class="mb-n2 " v-model="editedItem.cHomePage" label="홈페이지" :hint="'ex)' +  HomepageURL"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cTel" hint="['-' 제외하고 입력] 010 또는 011로 시작하는 번호는 입력이 불가 합니다.">
                <template v-slot:label>
                  <div>전화번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cFax" label="팩스번호" hint="[ 숫자만 입력 ] 없을시 작성안함"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field @click:append-outer="bDialogPost = true;" v-model="editedItem.cZip" append-outer-icon="search" readonly dense class="mb-n2">
                <template v-slot:label>
                  <div>우편번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cAddr1" :disabled="true">
                <template v-slot:label>
                  <div>기본주소<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field dense v-model="editedItem.cAddr2">
                <template v-slot:label>
                  상세주소<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="mb-3"></v-divider>
              <v-btn @click="editedItem = Object.assign({}, defaultItem);bStep = 1;" class="mr-2 mb-2" text><v-icon class="mr-1">mdi-chevron-left</v-icon>이전</v-btn>
              <!-- <v-btn @click="Close()" class="mr-2 mb-2" text><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn> -->
              <v-btn @click="SetCorp()" class="ml-2 mb-2" dark><v-icon class="mr-1">save</v-icon>저장</v-btn>
            </v-col>
          </v-row>            
        </v-card-text>
        <v-card-text v-if="bStep == 2 && editedItem.cLocal == 'N'" class="pa-4 pt-0 mt-8">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field dense class="mb-n2" v-model="editedItem.cBizCode" ref="cBizCode" disabled>
                <template v-slot:label>
                  <div>사업자번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
              <div></div>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" value="해외" label="기업구분" disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCorpNmKor" label="회사명(한글)" ref="cCorpNmKor"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2" v-model="editedItem.cCorpNmEng">
                <template v-slot:label>
                  <div>회사명(영문)<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cCEO">
                <template v-slot:label>
                  <div>대표자명<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <!-- <v-text-field dense class="mb-n2 " v-model="editedItem.cHomePage" label="홈페이지" hint="ex) https://www.sk-materials.com"></v-text-field> -->
              <v-text-field dense class="mb-n2 " v-model="editedItem.cHomePage" label="홈페이지" :hint="'ex)' +  HomepageURL"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cTel" hint="010 또는 011로 시작하는 번호는 입력이 불가 합니다.">
                <template v-slot:label>
                  <div>전화번호<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cFax" label="팩스번호" hint="[ 숫자만 입력 ] 없을시 작성안함"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="editedItem.cZip" label="우편번호" dense class="mb-n2" hint="[ 숫자만 입력 ] 없을시 작성안함"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field dense class="mb-n2 " v-model="editedItem.cAddr1">
                <template v-slot:label>
                  <div>기본주소<strong class="red--text">*</strong></div>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field dense v-model="editedItem.cAddr2" label="상세주소"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="mb-3"></v-divider>
              <v-btn @click="Close()" class="mr-2 mb-2" text><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
              <v-btn @click="SetCorp()" class="ml-2 mb-2" dark><v-icon class="mr-1">save</v-icon>저장</v-btn>
            </v-col>
          </v-row>            
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 우편번호찾기 다이올로그 -->
    <v-dialog v-model="bDialogPost"  max-width="500">              
      <template>
        <vue-daum-postcode @complete="oncomplete" />
      </template>
    </v-dialog>

    <v-dialog v-model="bGoLogin" persistent max-width="600">
      <v-card>
        <v-card-title class="headline red--text">이미 협력업체로 등록된 사업자번호입니다.</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <div class="text-h6 font-weight-bold">업체명 : {{oCheckCorp.cCorpNm}}</div>
          <div class="text-subtitle-1">회원가입 절차로 이동합니다.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="red darken-1" text @click="GoLogin()" class="font-weight-bold"><v-icon class="mr-2">check_circle</v-icon>확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"   
import EventBus from '@/eventBus.js';
import Util from "../Util.js";

export default {
  components: {
  },

  data: () => ({
    bDialog : false,
    bGoLogin : false,
    bDialogPost : false,
    bStep : 0,
    oCheckCorp : {
      cCorpNm : "",
      cCorpId : "",
      cLocal : "",
    },
    cDirectBizCode : "",
    editedItem : {
      cCorpId : "",
      cLocal : "Y",
      cBizCode : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      cHomePage : "",
      cCEO : "",
      cTel : "",
      cFax : "",
      cZip : "",
      cAddr1 : "",
      cAddr2 : "",
    },
    defaultItem : {
      cCorpId : "",
      cLocal : "Y",
      cBizCode : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      cHomePage : "",
      cCEO : "",
      cTel : "",
      cFax : "",
      cZip : "",
      cAddr1 : "",
      cAddr2 : "",
    },
  }),
  
  computed: {
    ...mapState(["HomepageURL"]),
  },
  
  created() {
  },

  
  methods: {
    Open() {
      this.bDialog = true;
      this.bGoLogin = false;
      this.bStep = 1;
      setTimeout(() => {
        this.$refs.cBizCodeKorRef.focus()
      }, 10);
    },

    ChangeFocus(){
      this.editedItem.cBizCode = '';
      if (this.editedItem.cLocal == 'Y') {
        setTimeout(() => {
          this.$refs.cBizCodeKorRef.focus()
        }, 10);
      } else {
        setTimeout(() => {
          this.$refs.cBizCodeEngRef.focus()
        }, 10);
      }
    },

    Close() {
      this.bDialog = false;
      this.bStep = 0;
      this.editedItem  = Object.assign({}, this.defaultItem);
    },

    UseAPI(){
      let ReBizCode = this.editedItem.cBizCode.replace(/-/g,'')
      if (ReBizCode.length != 10) {
        EventBus.$emit("onShowMsgBox","입력하신 사업자 번호의 형식이 올바르지 않습니다.", "10자리의 숫자만 입력 하여 주세요.");
        return
      }
      
      if (!/[0-9]{10}$/.test(ReBizCode)) {
        EventBus.$emit("onShowMsgBox","입력하신 사업자 번호의 형식이 올바르지 않습니다.", "10자리의 숫자만 입력 하여 주세요.");
        return
      }
      this.editedItem.cBizCode = ReBizCode

      const serviceKey = 'ezOvlcdSnta4n%2FzxgMUd05ZOz%2FNARMuD7r5br%2FX7sYOzR3juvsfQN549b4uQ%2BR9Mf614N6JhRFl2YDMAFhwM7A%3D%3D'; //일반 인증키(Encoding) 사용
      const apiUrl = `https://api.odcloud.kr/api/nts-businessman/v1/status?serviceKey=${serviceKey}`;

      axios
        .post(apiUrl, {
          b_no: [this.editedItem.cBizCode]
        })
        .then(res => {
          if (res.data.data[0].tax_type === "국세청에 등록되지 않은 사업자등록번호입니다.") {
            EventBus.$emit("onShowMsgBox","사업자 번호를 다시 확인하여 주세요.", "국세청에 등록되지 않은 사업자등록번호입니다.");
            this.editedItem.cBizCode = ""
          } else {
            this.CheckBizCode()
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    CheckBizCode(){
      this.oCheckCorp = {};
      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        cBizCode : this.editedItem.cBizCode,
        cLocal : this.editedItem.cLocal,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "CheckBizCode", posData, {
          headers: {
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            this.bStep = 2;
            EventBus.$emit("onShowMsg", false, "등록이 가능한 사업자 번호 입니다.");
          } else {
            this.oCheckCorp.cCorpNm = res.data.Result[0].cCorpNm
            this.oCheckCorp.cCorpId = res.data.Result[0].cCorpId
            this.oCheckCorp.cLocal = res.data.Result[0].cLocal
            this.Close();
            this.bGoLogin = true
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    GoLogin() {
      this.bGoLogin = false
      this.$emit("GoResistCustom",this.oCheckCorp);
    },

    CheckBizCodeEng() {
      let ReBizCode = this.editedItem.cBizCode.replace(/-/g,'')
      if (this.editedItem.cBizCode == '') {
        EventBus.$emit("onShowMsgBox","사업자 번호를 입력하여 주세요.", "등록하시려는 업체의 사업자 번호를 입력하여 주세요.");
        return
      }

      if (ReBizCode.length != 9) {
        EventBus.$emit("onShowMsgBox","입력하신 사업자 번호의 형식이 올바르지 않습니다.", "9자리의 숫자만 입력 하여 주세요.");
        return
      }

      if (!/[0-9]{9}$/.test(ReBizCode)) {
        EventBus.$emit("onShowMsgBox","입력하신 사업자 번호의 형식이 올바르지 않습니다.", "-를 제외한 9자리의 DUNS 번호를 입력하여 주세요.");
        return
      }
      this.editedItem.cBizCode = ReBizCode

      this.CheckBizCode()
    },

    SetCorp() {
      if (this.editedItem.cLocal == "Y") {
        if (this.editedItem.cBizCode == "" ) {
          EventBus.$emit("onShowMsgBox","사업자번호는 필수입력 항목입니다.", "사업자번호 항목을 확인하여 주세요.");
          return;
        }
        if (this.editedItem.cCorpNmKor == "" ) {
          EventBus.$emit("onShowMsgBox","회사이름(한글)는 필수입력 항목입니다.", "회사이름(한글) 항목을 확인하여 주세요.");
          return;
        } 
        if (this.editedItem.cCEO == "" ) {
          EventBus.$emit("onShowMsgBox","대표자명은 필수입력 항목입니다.", "대표자명 항목을 확인하여 주세요.");
          return;
        }
        if (this.editedItem.cHomePage != "" ) {
          if (!Util.CheckURL(this.editedItem.cHomePage)) {
            EventBus.$emit("onShowMsgBox","홈페이지의 입력 방식이 잘못 되었습니다.", "입력하신 홈페이지 주소를 다시 확인하여 주세요.");
            return;
          }
        }
        if (this.editedItem.cTel == "" ) {
          EventBus.$emit("onShowMsgBox","전화번호는 필수입력 항목입니다.", "전화번호 항목을 확인하여 주세요.");
          return;
        }
        if (!Util.CheckLinePhoneNum(this.editedItem.cTel)) {
          if (!(this.editedItem.cTel.length == 10 || this.editedItem.cTel.length == 11)) {
            EventBus.$emit("onShowMsgBox", "전화번호가 정확하지 않습니다.","'-' 를 제외하고 010 또는 011로 시작하는 번호는 입력할 수 없습니다.");
          } else {
            EventBus.$emit("onShowMsgBox", "전화번호가 정확하지 않습니다.","형식에 맞게 입력하여 주세요.");
          }
          return
        }

        if (this.editedItem.cFax != "") {
          if (this.editedItem.cFax.length > 11) {
            EventBus.$emit("onShowMsgBox","입력하신 팩스번호가 정확하지 않습니다.", " '-'를 제외한 10자리나 11자리의 숫자로 입력하여 주세요.");
            return;
          }
          if (!/^0[0-9]{9,10}$/.test(this.editedItem.cFax)) {
            EventBus.$emit("onShowMsgBox","입력하신 팩스번호가 정확하지 않습니다.", " '-'를 제외한 10자리나 11자리의 숫자로 입력하여 주세요.");
            return;
          }
        }
        if (this.editedItem.cAddr1 == "" || this.editedItem.cAddr2 == "" ) {
          EventBus.$emit("onShowMsgBox","주소는 필수입력 항목입니다.", "기본 주소와 상세 주소 항목을 확인하여 주세요.");
          return;
        }
      } else if (this.editedItem.cLocal == "N") {
        if (this.editedItem.cBizCode == "" ) {
          EventBus.$emit("onShowMsgBox","사업자번호는 필수입력 항목입니다.", "사업자번호 항목을 확인하여 주세요.");
          return;
        }
        if (this.editedItem.cCorpNmEng == "" ) {
          EventBus.$emit("onShowMsgBox","회사이름(영문)는 필수입력 항목입니다.", "회사이름(영문) 항목을 확인하여 주세요.");
          return;
        } 
        if (this.editedItem.cCEO == "" ) {
          EventBus.$emit("onShowMsgBox","대표자명은 필수입력 항목입니다.", "대표자명 항목을 확인하여 주세요.");
          return;
        }
        if (this.editedItem.cHomePage != "" ) {
          if (!Util.CheckURL(this.editedItem.cHomePage)) {
            EventBus.$emit("onShowMsgBox","홈페이지의 입력 방식이 잘못 되었습니다.", "입력하신 홈페이지 주소를 다시 확인하여 주세요.");
            return;
          }
        }
        if (!Util.CheckLinePhoneNum(this.editedItem.cTel)) {
          if (!(this.editedItem.cTel.length == 10 || this.editedItem.cTel.length == 11)) {
            EventBus.$emit("onShowMsgBox", "전화번호가 정확하지 않습니다.","'-' 제외하고 10자리 혹은 11자리의 숫자만 입력해 주세요.");
          } else {
            EventBus.$emit("onShowMsgBox", "전화번호가 정확하지 않습니다.","형식에 맞게 입력하여 주세요.");
          }
          return
        }
        if (this.editedItem.cFax != "") {
          if (this.editedItem.cFax.length > 11) {
            EventBus.$emit("onShowMsgBox","입력하신 팩스번호가 정확하지 않습니다.", " '-'를 제외한 10자리나 11자리의 숫자로 입력하여 주세요.");
            return;
          }
          if (!/^0[0-9]{9,10}$/.test(this.editedItem.cFax)) {
            EventBus.$emit("onShowMsgBox","입력하신 팩스번호가 정확하지 않습니다.", " '-'를 제외한 10자리나 11자리의 숫자로 입력하여 주세요.");
            return;
          }
        }
        if (this.editedItem.cAddr1 == "") {
          EventBus.$emit("onShowMsgBox","주소는 필수입력 항목입니다.", "기본 주소 항목을 확인하여 주세요.");
          return;
        } 
      }

      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        cCorpId: this.editedItem.cCorpId,
        cCorpNmKor: this.editedItem.cCorpNmKor,
        cCorpNmEng: this.editedItem.cCorpNmEng,
        cBizCode: this.editedItem.cBizCode,
        cLocal: this.editedItem.cLocal,
        cCEO: this.editedItem.cCEO,
        cTel: this.editedItem.cTel,
        cFax: this.editedItem.cFax,
        cHomePage: this.editedItem.cHomePage,
        cZip: this.editedItem.cZip,
        cAddr1: this.editedItem.cAddr1,
        cAddr2: this.editedItem.cAddr2,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetCorp", posData, {
          headers: {
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {              
            this.Close();
            this.$emit("GoLogin","cCorpNm");
            EventBus.$emit("onShowMsg",false, "협력업체 등록이 완료되었습니다.");
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","사업자 번호가 중복 되었습니다.", "입력하신 사업자 번호를 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,"("+res.data.ResultCd+ ") "+res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    oncomplete: function(result){
      this.editedItem.cZip = result.zonecode;
      if(result.userSelectedType === 'R'){
        this.editedItem.cAddr1 = result.roadAddress
      } else {
        this.editedItem.cAddr1 = result.jibunAddress
      }
      this.bDialogPost = false
    },
  }
};
</script>
